module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_4.7f6c9317.png";